module.exports = __webpack_public_path__ + "img/vertical_4_2_7005.6fac6ee8.png";